import {Grid, Tab} from '@mui/material';
import React, {SyntheticEvent, useState} from 'react';
import {TabContext} from "@mui/lab";
import {BorderBottomGrey200Tabs, SummaryTabPanel} from "./styles";
import LocationsBuyerBooked from '../LocationsBuyerBooked/LocationsBuyerBooked';
import LocationsBuyerFavorites from '../LocationsBuyerFavorites';
import {SecurSpaceContainer, SecurSpaceReportContainer} from "../../../../components/common";

const locationsBuyerSummaryTabs = [
  {
    value: "booked",
    label: "Booked Locations",
    component: <LocationsBuyerBooked />
  },
  {
    value: "favorite",
    label: "Favorite Locations",
    component: <LocationsBuyerFavorites />
  },
];

const LocationsBuyerSummary = () => {
  const [currentTab, setCurrentTab] = useState(locationsBuyerSummaryTabs[0].value);

  const handleTabChange = (_event: SyntheticEvent, value: 'booked' | 'favorite') => {
    setCurrentTab(value);
  }

  return <SecurSpaceContainer>
    <SecurSpaceReportContainer>
      <Grid item xs={12}>
        <TabContext value={currentTab + ''}>
          <BorderBottomGrey200Tabs
            variant={'fullWidth'}
            value={currentTab}
            onChange={handleTabChange}
            aria-label={'Account Tabs'}
            textColor={'secondary'}
          >
            {
              locationsBuyerSummaryTabs.map(tab => (
                <Tab key={tab.value} value={tab.value} label={tab.label}/>
              ))
            }
          </BorderBottomGrey200Tabs>
          {
            locationsBuyerSummaryTabs.map(tab => (
              <SummaryTabPanel key={tab.value} value={tab.value}>
                {tab.component}
              </SummaryTabPanel>
            ))
          }
        </TabContext>
      </Grid>
    </SecurSpaceReportContainer>
  </SecurSpaceContainer>
};

export default LocationsBuyerSummary;
